import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarCentroPayload, paramsListCentros, atualizarCentroPayload } from '../../interfaces/centros'

export function novoCentro (payload: cadastrarCentroPayload) {
    return BASEURLGESTTOR.post('/centros', payload)
}

export function lisatarCentros (params: paramsListCentros) {
    return BASEURLGESTTOR.get (`/centros?descricao=${params.descricao}&situacao=${params.situacao}`)
}

export function atualizarCentro (idCentro: string, payload: atualizarCentroPayload) {
    return BASEURLGESTTOR.patch(`/centros?idCentro=${idCentro}`, payload)
}
